module.exports = __webpack_public_path__ + "img/expDp.82786dd9.svg";